var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"level"},[_c('div',{staticClass:"level-left"},[_c('div',{staticClass:"level-item"},[_vm._t("left")],2)]),_c('div',{staticClass:"level-right"},[_c('div',{staticClass:"level-item"},[_vm._t("right")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }